// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonActions = {
  all: "All",
  save: "Save",
  restoreDefault: "Restore defaults",
  cancel: "Cancel",
  confirm: "Confirm",
  view: "View",
  edit: "Edit",
  back: "Back",
  close: "Close",
  logout: "Log out",
  changePassword: "Change password",
  exitImpersonation: "Exit impersonation",
  add: "Add",
  create: "Create",
  upload: "Upload",
  import: "Import",
  delete: "Delete",
  destroy: "Destroy",
  confirmDelete: "Confirm Delete",
  publish: "Publish",
  preview: "Preview",
  viewDetail: "View",
  saveChanges: "Save changes",
  updatePassword: "Update password",
  search: "Search",
  reset: "Reset",
  prevStep: "Previous Step",
  nextStep: "Next Step",
  viewAll: "View all",
  viewLoginOnly: "Login logs only",
  run: "Run",
  stop: "Stop",
  share: "Share",
  copy: "Copy",
  download: "Download",
  archive: "Archive",
  restore: "Restore",
  enable: "Enable",
  disable: "Disable",
  retry: "Retry",
  generate: "Generate",
  configure: "Configure",
  commit: "Commit",
  compare: "Compare",
  resetPassword: "Reset Password",
  unlock: "Unlock",
  lock: "Lock",
  extend: "Extend",
  refresh: "Refresh",
  enter: "Enter",
  open: "Open",
  more: "More",
  select: "Select",
  clear: "Clear",
  filtered: "Filtered",
  selectFile: "Select file",
  selectCurrentPage: "Select all",
  selectAcrossPagesMax: "Select across pages",
  clearSelection: "Clear selection",
  batchActions: "Batch actions",
} as const;

export const commonSemanticActionLabels = {
  destroy: commonActions.destroy,
  generate: commonActions.generate,
  configure: commonActions.configure,
  commit: commonActions.commit,
  compare: commonActions.compare,
  resetPassword: commonActions.resetPassword,
  unlock: commonActions.unlock,
  lock: commonActions.lock,
  extend: commonActions.extend,
} as const;
